var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.routeName,attrs:{"id":"app"}},[_c('VSpinner'),_c('div',{staticClass:"container"},[_c('RouterView')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }